import script from "./ProjectView.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectView.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectView.vue?vue&type=style&index=0&id=9a2f1540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a2f1540"]])

export default __exports__